import React from 'react';
import Button from '../../atoms/Button';
import Icon from '../../atoms/Icon';
import Navigation from '../molecules/Navigation';
import './DashboardSidebar.css';

interface NavItemData {
  id: string;
  label: string;
  icon: 'dashboard' | 'cart' | 'cake' | 'calendar' | 'users' | 'chart' | 'gear' | 'storefront';
}

interface DashboardSidebarProps {
  navItems: NavItemData[];
  activeTab: string;
  isCollapsed: boolean;
  isOpen?: boolean;
  onTabChange: (tabId: string) => void;
  onLogout: () => void;
}

const DashboardSidebar: React.FC<DashboardSidebarProps> = ({
  navItems,
  activeTab,
  isCollapsed,
  isOpen,
  onTabChange,
  onLogout
}) => {
  const sidebarClasses = [
    'dashboard-sidebar',
    isCollapsed ? 'collapsed' : '',
    isOpen ? 'open' : ''
  ].filter(Boolean).join(' ');

  return (
    <aside className={sidebarClasses}>
      <div className="sidebar-header">
        <img src="/images/logo/tfr.avif" alt="The Frosting Room" className="sidebar-logo" />
        {!isCollapsed && <h2>The Frosting Room</h2>}
      </div>

      <Navigation
        items={navItems}
        activeTab={activeTab}
        isCollapsed={isCollapsed}
        onTabChange={onTabChange}
      />

      <div className="sidebar-footer">
        <button
          className="logout-button"
          onClick={onLogout}
        >
          <Icon type="logout" size="small" />
          {!isCollapsed && <span>Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default DashboardSidebar;
